module.exports = __webpack_public_path__ + "static/media/plant-normal.9f4f6502.png";